<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-printer-3d</v-icon>{{$t('profile.machine.models')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <MachineModelForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import MachineModelForm from '../../components/machinemodel/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'MachineModel';

const { mapFields } = createHelpers({
  getterType: 'machinemodel/getField',
  mutationType: 'machinemodel/updateField'
});

export default {
  name: 'MachineModelCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    MachineModelForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('machinemodel', ['create', 'reset'])
  }
};
</script>
